import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip as RechartsTooltip,
  CartesianGrid,
  ResponsiveContainer,
} from 'recharts';
import type { SpendRow } from './listingMetrics';
import { money, moneyCompact } from './listingMetrics';

export const SpendTrendChart: React.FC<{ rows: SpendRow[] }> = ({ rows }) => {
  const hasData = rows.some((r) => r.amount + r.refunded > 0);
  const tickInterval = rows.length > 12 ? Math.ceil(rows.length / 8) : 0;

  return (
    <div className="relative">
      <div className="h-56 w-full">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={rows} margin={{ top: 8, right: 8, left: 8, bottom: 0 }} barCategoryGap="24%">
            <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#eef2f6" />
            <XAxis
              dataKey="label"
              tickLine={false}
              axisLine={false}
              interval={tickInterval}
              tick={{ fontSize: 11, fill: '#9ca3af' }}
            />
            <YAxis
              hide={false}
              width={52}
              tickLine={false}
              axisLine={false}
              tick={{ fontSize: 11, fill: '#9ca3af' }}
              tickFormatter={(v: number) => moneyCompact(v)}
            />
            <RechartsTooltip
              cursor={{ fill: 'rgba(0,0,0,0.03)' }}
              contentStyle={{ fontSize: 12, borderRadius: 8, border: '1px solid #e5e7eb' }}
              formatter={(v: number, name: string) => [money(v), name]}
            />
            <Bar dataKey="amount" name="Spend" fill="#16a34a" radius={[3, 3, 0, 0]} maxBarSize={28} minPointSize={2} />
            <Bar dataKey="refunded" name="Refunded" fill="#f43f5e" radius={[3, 3, 0, 0]} maxBarSize={28} />
          </BarChart>
        </ResponsiveContainer>
      </div>

      <div className="mt-3 flex flex-wrap items-center gap-x-5 gap-y-1.5">
        <span className="flex items-center gap-1.5 text-xs text-gray-600">
          <span className="h-2.5 w-2.5 rounded-full" style={{ backgroundColor: '#16a34a' }} /> Spend
        </span>
        <span className="flex items-center gap-1.5 text-xs text-gray-600">
          <span className="h-2.5 w-2.5 rounded-full" style={{ backgroundColor: '#f43f5e' }} /> Refunded
        </span>
      </div>

      {!hasData && (
        <div className="pointer-events-none absolute inset-0 flex items-center justify-center">
          <span className="rounded-full bg-gray-50 px-3 py-1 text-xs text-gray-400">No spend recorded</span>
        </div>
      )}
    </div>
  );
};
